export default __webpack_public_path__ + "static/media/folder.87bd7c33.svg";